import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RetailerAttributeDefinitionsComponent } from '@src/app/features/retailer-attribute-definitions/retailer-attribute-definitions/retailer-attribute-definitions.component';
import { AddRetailerAttributeDefinitionsComponent } from '@src/app/features/retailer-attribute-definitions/add-retailer-attribute-definitions/add-retailer-attribute-definitions.component';
import { EditRetailerAttributeDefinitionsComponent } from '@src/app/features/retailer-attribute-definitions/edit-retailer-attribute-definitions/edit-retailer-attribute-definitions.component';
import { ViewRetailerAttributeDefinitionsComponent } from '@src/app/features/retailer-attribute-definitions/view-retailer-attribute-definitions/view-retailer-attribute-definitions.component';

const routes: Routes = [
  { path: '', component: RetailerAttributeDefinitionsComponent },
  { path: 'add', component: AddRetailerAttributeDefinitionsComponent },
  { path: ':productAttributesDefinitionId/edit', component: EditRetailerAttributeDefinitionsComponent },
  { path: ':productAttributesDefinitionId', component: ViewRetailerAttributeDefinitionsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RetailerAttributeDefinitionsRoutingModule { }
